export function getLabItemKey(item) {
  if (!item) return "";
  if (item.id) return String(item.id);
  const code = item.partnerTestCode || item.labTestCode || "";
  const lab = item.diagnosticsCode || item.diagnosticsName || "";
  return `${code}-${lab}`;
}

export function getLabDisplayName(item) {
  return item?.displayName || item?.partnerTestName || item?.labTestName || "";
}

export function getLabDisplayPrice(item) {
  if (!item) return null;
  const price = Number(item.listPrice ?? item.amount ?? item.price);
  if (Number.isNaN(price) || price <= 0) return null;
  return Number.isInteger(price) ? price : Number(price.toFixed(2));
}

export function getLabSectionKey(item) {
  const category = (item?.category || "").toLowerCase();
  const name = getLabDisplayName(item).toLowerCase();
  if (category.includes("package") || name.includes("package")) {
    return "PACKAGES";
  }
  const type = (item?.labType || "").toLowerCase();
  if (type.includes("radiology")) return "RADIOLOGY";
  return "PATHOLOGY";
}
